import React, { useEffect, useRef, useState } from 'react';

import { GOOGLE_CLIENT_ID } from '@src/env';
import { Google } from '@src/google';

export default function MarketingLeadCaptureWithGoogle({
  eventName,
  formLocation,
  leadType,
  returningUri,
  shareGuid,
  text = 'continue_with',
  verificationUri,
}: {
  eventName: 'createLeadWithGoogle' | 'unlockContentWithGoogle';
  formLocation: string;
  leadType: string;
  returningUri?: string;
  shareGuid?: string;
  text?: 'signin_with' | 'signup_with' | 'continue_with' | 'signin';
  verificationUri: string;
}) {
  const [google, setGoogle] = useState<Google>();
  const googleSignInButton = useRef(null);

  useEffect(() => {
    if (!google) {
      setGoogle(window.google);
    }
  }, [google]);

  useEffect(() => {
    if (google) {
      google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback:
          eventName === 'createLeadWithGoogle'
            ? window.createLeadWithGoogle
            : window.unlockContentWithGoogle,
      });

      google.accounts.id.renderButton(googleSignInButton.current, {
        type: 'standard',
        text,
        width: 250,
      });
    }
  }, [eventName, text, google]);

  return (
    <div
      ref={googleSignInButton}
      data-callback={eventName}
      data-redirect-uri={verificationUri}
      data-returning-uri={returningUri}
      data-lead-type={leadType}
      data-page={window.location.pathname}
      data-form-location={formLocation}
      data-share-guid={shareGuid}
    />
  );
}
